<template>
  <div>
    <div class="page-title-wrapper">
      <div
        v-if="hasMessagePermissions"
        class="page-title mr-4"
        :class="{ active: page === 'messages' }"
        @click="showMessages"
      >
        {{ $t('menu.messages') }}
        <span
          v-if="unreadMessages"
          class="badge badge-pill badge-danger tab-count"
        >{{ unreadMessages }}</span>
      </div>
      <div
        v-if="hasMessagePermissions"
        class="page-title mr-4"
        :class="{ active: page === 'posts' }"
        @click="showPosts"
      >
        {{ $t('menu.posts') }}
      </div>
      <div
        v-if="payeeAdmin"
        class="page-title mr-4"
        :class="{ active: page === 'notifications' }"
        @click="showNotifications"
      >
        {{ $t('menu.notifications') }}
      </div>
      <div
        v-if="payeeAdmin"
        class="page-title mr-4"
        :class="{ active: page === 'banners' }"
        @click="showBanners"
      >
        {{ $t('menu.homeBanners') }}
      </div>
      <div
        class="page-title"
        :class="{ active: page === 'news' }"
        @click="showNews"
      >
        {{ $t('news.tab') }}
        <span
          v-if="unreadNews"
          class="badge badge-pill badge-danger tab-count"
        >{{ unreadNews }}</span>
      </div>
    </div>
    <div class="mt-2">
      <RouterView
        @page="page = $event"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    page: '',
  }),
  computed: {
    ...mapGetters(['payeeId', 'payeeAdmin', 'permissions', 'unreadMessages', 'unreadNews']),
    hasMessagePermissions() {
      return this.payeeAdmin || this.permissions
        .some((x) => x.type === 'MessageAdmin' && x.scope?.payeeId === this.payeeId);
    },
  },
  watch: {
    $route() {
      this.redirectWithoutPermissions();
    },
    hasMessagePermissions() {
      this.redirectWithoutPermissions();
    },
  },
  methods: {
    showMessages() {
      this.$router.push(`/payee/${this.payeeId}/messages/messages`);
    },
    showPosts() {
      this.$router.push(`/payee/${this.payeeId}/messages/posts`);
    },
    showNotifications() {
      this.$router.push(`/payee/${this.payeeId}/messages/notifications`);
    },
    showBanners() {
      this.$router.push(`/payee/${this.payeeId}/messages/banners`);
    },
    showNews() {
      this.$router.push(`/payee/${this.payeeId}/messages/news`);
    },
    // Staff without message access only have the "Co nowego" tab.
    redirectWithoutPermissions() {
      if (!this.permissions.length || this.hasMessagePermissions) {
        return;
      }

      const path = this.$route.path || '';
      if (!path.includes('/messages/news')) {
        this.$router.replace(`/payee/${this.payeeId}/messages/news`);
      }
    },
  },
  created() {
    this.$emit('page', 'messages');
    this.redirectWithoutPermissions();
  },
};
</script>

<style lang="scss" scoped>
// Five tabs don't fit in the default 500px, which made "Co nowego" wrap.
.page-title-wrapper {
  max-width: none;
}

.page-title {
  white-space: nowrap;
}

.tab-count {
  font-size: 11px;
  vertical-align: top;
}
</style>
